import LazyImage from "../components/LazyImage";
import logo from "../assets/images/logoOne.png";
import outline from "../assets/images/outline2.png";

const Contact = () => (
  <div className="p-10">
    <div className="relative z-10">
      <h1 className="title romanStandard text-sm">Contact</h1>
      <p className="romanStandard">Contact us and let’s have a chat.</p>
      <p className="romanStandard">Aaron</p>
      <p className="romanStandard">
        <a href="tel:+6421607949">021 607 949</a>
      </p>
      <p className="romanStandard">
        <a href="mailto:aaron@motographic.co.nz">aaron@motographic.co.nz</a>
      </p>
      <LazyImage
        src={logo}
        alt="Motographic"
        className="w-[150px] pt-5"
        priority
      />
    </div>
    {/* Decorative background: empty alt keeps it out of the a11y tree. */}
    <LazyImage
      src={outline}
      alt=""
      aria-hidden="true"
      className="absolute inset-0 w-full h-full object-cover opacity-30"
    />
  </div>
);

export default Contact;
